@if (designerMapState.mapObjectTablesState[0].mapObjects.length) {
  <gk-map-object-table
    [mapState]="designerMapState"
    [mapObjectTableStateIndex]="0"
    (dispatch)="handleMapAction($event)"
  ></gk-map-object-table>
}
<gk-map [mapState]="designerMapState" (dispatch)="handleMapAction($event)"></gk-map>
